import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('taa_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const publicApi = {
  listOffers: (category) => api.get('/offers', { params: category ? { category } : {} }).then((r) => r.data),
  getPopup: (page) => api.get('/popups', { params: { page } }).then((r) => r.data),
  submitForm: (type, data) => api.post(`/submissions/${type}`, { data }).then((r) => r.data),
};

export const adminApi = {
  login: (email, password) => axios.post(`${API_BASE}/auth/login`, { email, password }).then((r) => r.data),
  me: () => api.get('/auth/me').then((r) => r.data),
  uploadFile: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/files/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  fileUrl: (urlOrPath) => {
    if (!urlOrPath) return '';
    if (/^https?:\/\//.test(urlOrPath)) return urlOrPath;
    return `${BACKEND_URL}${urlOrPath}`;
  },
  // Offers
  listOffers: (category, includeInactive = true) => api.get('/offers', { params: { category, include_inactive: includeInactive } }).then((r) => r.data),
  createOffer: (payload) => api.post('/offers', payload).then((r) => r.data),
  updateOffer: (id, payload) => api.put(`/offers/${id}`, payload).then((r) => r.data),
  deleteOffer: (id) => api.delete(`/offers/${id}`).then((r) => r.data),
  // Popups
  listPopups: () => api.get('/popups', { params: { include_inactive: true } }).then((r) => r.data),
  createPopup: (payload) => api.post('/popups', payload).then((r) => r.data),
  updatePopup: (id, payload) => api.put(`/popups/${id}`, payload).then((r) => r.data),
  deletePopup: (id) => api.delete(`/popups/${id}`).then((r) => r.data),
  // Submissions
  listSubmissions: (type) => api.get('/submissions', { params: type ? { type } : {} }).then((r) => r.data),
  deleteSubmission: (id) => api.delete(`/submissions/${id}`).then((r) => r.data),
  exportCsv: (type) => `${API_BASE}/submissions/export/csv${type ? `?type=${type}` : ''}`,
  stats: () => api.get('/stats').then((r) => r.data),
  // Short links
  listShortLinks: (q) => api.get('/short-links', { params: q ? { q } : {} }).then((r) => r.data),
  createShortLink: (payload) => api.post('/short-links', payload).then((r) => r.data),
  updateShortLink: (id, payload) => api.put(`/short-links/${id}`, payload).then((r) => r.data),
  deleteShortLink: (id) => api.delete(`/short-links/${id}`).then((r) => r.data),
  shortLinkClicks: (id) => api.get(`/short-links/${id}/clicks`).then((r) => r.data),
  // Customer Journey
  journey: (q) => api.get('/journey', { params: { q } }).then((r) => r.data),
};

// Short-link URL builder. Short URLs live on the same domain as the site
// (e.g. https://theloanalliance.com/track/{slug}) so the anchor href, hover
// preview, and address bar all display our own brand.
export const SHORT_LINK_BASE = process.env.REACT_APP_SHORT_LINK_BASE_URL || 'https://theloanalliance.com/track';

export function shortLinkUrl(slug) {
  if (!slug) return '';
  return `${SHORT_LINK_BASE.replace(/\/$/, '')}/${slug}`;
}

// Kept for backwards-compat with any older code paths — same-domain short links
// don't need any URL rewrite, so this now returns the input unchanged.
export function clickThroughUrl(urlOrShort) {
  return urlOrShort || '';
}

export function bannerUrl(urlOrPath) {
  if (!urlOrPath) return '';
  if (/^https?:\/\//.test(urlOrPath)) return urlOrPath;
  return `${BACKEND_URL}${urlOrPath}`;
}
